import { Controller } from 'stimulus'
import { request } from './request'

export default class extends Controller {
  static targets = ['list', 'input', 'bar', 'count', 'empty', 'template']

  add(event) {
    event.preventDefault()
    const title = this.inputTarget.value.trim()
    if (!title) return

    this.inputTarget.disabled = true
    request(this.data.get('url'), { method: 'POST', body: { title } }).then(({ ok, data }) => {
      this.inputTarget.disabled = false
      if (!ok) return window.alert(data.error || '')

      const node = this.templateTarget.content.firstElementChild.cloneNode(true)
      node.dataset.taskId = data.id
      node.querySelector('[data-task-title]').textContent = data.title
      this.listTarget.appendChild(node)
      this.inputTarget.value = ''
      this.inputTarget.focus()
      this.refresh()
    })
  }

  toggle(event) {
    const row  = event.target.closest('[data-task-id]')
    const done = event.target.checked
    row.classList.toggle('is-done', done)
    request(`${this.data.get('url')}/${row.dataset.taskId}`, { method: 'PATCH', body: { done } })
    this.refresh()
  }

  remove(event) {
    const row = event.target.closest('[data-task-id]')
    request(`${this.data.get('url')}/${row.dataset.taskId}`, { method: 'DELETE' })
    row.remove()
    this.refresh()
  }

  refresh() {
    const rows  = this.listTarget.querySelectorAll('[data-task-id]')
    const done  = this.listTarget.querySelectorAll('[data-task-id] input:checked').length
    const total = rows.length
    if (this.hasBarTarget)   this.barTarget.style.width = total ? `${Math.round(done * 100 / total)}%` : '0%'
    if (this.hasCountTarget) this.countTarget.textContent = total ? `${done}/${total}` : ''
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle('hidden', total > 0)
  }
}
